/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import ContactListItem from './ContactListItem'

export type ContactListProps = {
  items: Contact[]
}

function ContactList (props: ContactListProps) {
  const { items } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th style={{ width: 50 }}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="name"
              defaultMessage="Nom"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 150 }}
          >
            <FormattedMessage
              id="mobile"
              defaultMessage="Mobile"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 150 }}
          >
            <FormattedMessage
              id="phone"
              defaultMessage="Téléphone"
            />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="email"
              defaultMessage="Email"
            />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="state"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 200 }}
          >
            <FormattedMessage
              id="modified_at"
              defaultMessage="Modifié le"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <ContactListItem
              item={item}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={7}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default ContactList
